import React from 'react'
import { Route } from 'react-router-dom'
import { IndexSchedulesTesting, SchedulesTestingCreate, SchedulesTestingEdit, SchedulesTestingMain, SchedulesTestingview } from '../Views/Web/TestingAndCommissioning/Schedules/Index'
import MainTestingAndCommissioning from '../Views/Web/TestingAndCommissioning/MainTestingAndCommissioning'
import Forms from '../Views/Web/TestingAndCommissioning/Schedules/Forms'

function TestingAndCommisioningRoutes() {
    return (
      <Route path="testingAndcommisioning" element={<MainTestingAndCommissioning />}>
          <Route path="schedules" element={<SchedulesTestingMain/>} >
           <Route index element={<IndexSchedulesTesting/>} />
           <Route path='create' element={<SchedulesTestingCreate/>} />
           <Route path='edit/:scheduleEditId' element={<SchedulesTestingEdit/>} />
           <Route path='view/:scheduleViewId' element={<SchedulesTestingview/>} />
           <Route path='forms/:scheduleViewId' element={<Forms/>} />

          </Route>
          
      </Route>
    )
  }
  
  export default TestingAndCommisioningRoutes